


































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class AxInput extends Vue {
  @Prop({ type: String })
  width!: string;

  @Prop({ type: String })
  height!: string;

  @Prop()
  lighten!: boolean;
}
